import UseCasesTabsComponent from "./use-cases-tabs-component";
import UseCasesTabsConfig from "./use-cases-tabs-config";
import UseCasesTabsAdvancedConfig from "./use-cases-tabs-advanced-config";

export default {
  UseCasesTabsComponent,
  UseCasesTabsConfig,
  UseCasesTabsAdvancedConfig
};
